module.exports = __webpack_public_path__ + "static/img/装饰17.cc3d7a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰17.svg
// module id = kEOi
// module chunks = 2